import { Box, Loader } from '@ksyos/design-system';

export function MonitoringLoader(): JSX.Element {
    return (
        <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
        >
            <Loader />
        </Box>
    );
}
